import React, {useEffect, useState} from "react";

import Box from "@mui/material/Box";

import "../App.css"
import {PageHeader} from "./PageHeader";

import {CxGrid} from "../cmx/CxGrid";
import {CxButton} from "../cmx/CxForm"
import {CxDataPairs} from "../cmx/CxData"
import {CxFormFeedback} from "../cmx/CxFeedback";
import {CxText} from "../cmx/CxTypography"
import {initialCall, runningCall, successCall} from "../gateway/CallService";
import {archiveCounts, archiveProjects} from "../gateway/ArchiveService"
import {JsonUtil} from "../lib/JsonUtil"

export function Archive() {

    const [call, setCall] = useState(initialCall())

    const labels = [
        { key: "zProjectCount",         label: "Archivierte Projekte" },
        { key: "zTaskCount",            label: "Archivierte Arbeitsvorgänge"},
        { key: "projectCount",          label: "Aktuelle Projekte"},
        { key: "taskCount",             label: "Aktuelle Arbeitsvorgänge"},
        { key: "projectCountToArchive", label: "Projekte zum archivieren"},
        { key: "taskCountToArchive",    label: "Arbeitsvorgänge zum archivieren"}
    ];

    const refreshArchiveCounts = async () => {
        setCall(runningCall());
        const responseCall = await archiveCounts();

        if (responseCall.isSuccess) {
            const values = JsonUtil.convertJsonStringToArray(responseCall.result);
            const items = labels.map(item => ({
                ...item,
                value: values[item.key] ?? null
            }));
            setCall(successCall(items));
        } else {
            setCall(responseCall);
        }
    };

    // initial load
    useEffect(() => {
        refreshArchiveCounts();
    }, []);


    const projectCountToArchive = call.isSuccess ? call.result.find(i => i.key === "projectCountToArchive")?.value : 0;

    const handleSubmit = async (action) => {
        setCall(runningCall);
        const responseCall = await archiveProjects()

        if (responseCall.isError) {
            setCall(responseCall)
        } else {
            await refreshArchiveCounts();
        }
    }

    return (
        <Box sx={{ width: '100%' }}>
            <CxGrid container spacing={2}>
                <PageHeader title="Archiv" />
                <CxText>
                    Abgeschlossene Projekte bei denen das Enddatum des letzte Arbeitsvorgangs 3. Monate oder länger zurückliegt,
                    können archiviert werden. <br />Einmal archivierte Projekte können via Suche wieder angezeigt (aber nicht mehr
                    bearbeitet) werden.
                </CxText>

                <CxFormFeedback call={call} />

                { call.isSuccess &&
                    <CxDataPairs items={call.result} />
                }
                { projectCountToArchive > 0 &&
                    <CxButton label="Archivieren" action="archive" handleSubmit={handleSubmit} />
                }

            </CxGrid>
        </Box>
    );
}

// --------------------------------------------------------------------------------------------------------------------
// The end.